<template>
<div id="akb">
    <div class="info title clearfix" style="background: url('/static/img/general/akb.jpg') 0 0 no-repeat;background-position: center center;">
        <div class="wrapper clearfix">
            <div class="col-xs-120">
                <h1>Аккумуляторы</h1>
            </div>
        </div>
    </div>
    <div class="container-fluid avtoservices-block">
        <h3 style="color: #4a80c6;"><center><br/>Вернем CashBack 10% при любой покупке + 500 рублей на счет за регистрацию.</center></h3>
    </div>

    <div class="category clearfix category-links" style="padding-bottom: 0px;">
        <div class="wrapper clearfix" style="padding-bottom: 20px;"><div class="col-xs-120 text_raw_main_div">
            <p>Аккумуляторные батареи АКБ для любых автомобилей и техники</p>
            <p>Выбирайте на нашем сайте из лучших предложений в нашем городе.</p>

            <h2>Аккумуляторы выбираются по следующим параметрам:</h2>
            <ul>
                <li>Габаритные размеры аккумулятора (длина, ширина, высота)</li>
                <li>Полярность (+/- , -/+, универсальный)</li>
                <li>Емкость батареи (от и до)</li>
                <li>Простой выбор АКБ – по марке и модели автомобиля, году выпуска (VIN)</li>
                <li>Выбирайте по стоимости: большой ряд отечественных и импортных аккумуляторов</li>
            </ul>
            <p>Специалисты помогут определиться с выбором и ответят на все Ваши вопросы.</p>
            <h2>Производители аккумуляторов</h2>
            <p>Более 20 производителей аккумуляторных батарей среди которых: аккумуляторы Bosch, Ford, Дельта, легендарные аккумуляторы Varta, отечественные аккумуляторы Тюмень и Подольского аккумуляторного завода, Патриот, Актех, Аком.
            </p>
            <h2>Акции и скидки на покупку аккумуляторов</h2>
            <p>Узнайте о специальных условиях и акциях на доставку и установку АКБ, а также прием старой аккумуляторной батареи и предоставлении скидки на новую. </p>
        </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Akb'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Akb.vue